module.exports = __webpack_public_path__ + "img/googlestreetmap.64b24489.jpg";